import React from 'react'
import styles from './styles.module.scss'

export type ListItem = {
  label: string
  value: string | number
  availability?: boolean
  flag?: React.ReactNode
}

export type SetSelectionArgs = Record<string, string | number>

export type ListProps = {
  optionClasses?: string
  list: readonly ListItem[]
  selection?: string | number | null
  setSelection: (args: SetSelectionArgs) => void
  id: string
  renderItem?: (item: ListItem) => React.ReactNode
}

function List({
  list,
  selection,
  setSelection,
  id,
  optionClasses,
  renderItem
}: ListProps) {
  const selectItem = (event: React.MouseEvent, item: ListItem) => {
    event.stopPropagation()
    const isNotAvailable = item?.availability === false

    if (isNotAvailable) {
      return null
    }

    setSelection({ [id]: item.value })
  }

  return (
    <>
      {list.map(item => {
        const isDisabled = item.availability === false
        return (
          <li key={`li_${item.value}_${id}`}>
            <button
              type="button"
              role="option"
              aria-selected={selection === item.value}
              className={`list-option-${id} ${styles.list__option__button} ${
                optionClasses || ''
              } ${selection === item.value ? styles.selected : ''} ${
                isDisabled ? styles.list__option_notAvailable : ''
              }`}
              onClick={(event: React.MouseEvent) => selectItem(event, item)}
              disabled={isDisabled}
              data-testid={`list-option-${item.value}`}
            >
              {renderItem ? renderItem(item) : item.label}
            </button>
          </li>
        )
      })}
    </>
  )
}

export default List
